import { deleteShipmentDate } from "../order/actions";
import {
  DELETE_SHIPMENT_DATE_FAIL,
  DELETE_SHIPMENT_DATE_REQUEST,
} from "../order/actionType";
import axios from "./utils/axios";

const fetchShipmentDateDelete = (shipment_id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELETE_SHIPMENT_DATE_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.delete(
        `api/order/delete_shipment/${shipment_id}/`,
        config
      );
      dispatch(deleteShipmentDate(data));
    } catch (error) {
      dispatch({
        type: DELETE_SHIPMENT_DATE_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchShipmentDateDelete;
